import { useId } from 'react'
import { SwitchProps } from './props.js'

export function Switch({
  checked,
  onChange,
  label,
  disabled = false,
  className = '',
}: SwitchProps) {
  const id = useId()

  const containerClasses = [
    'inline-flex items-center gap-3',
    disabled && 'opacity-38',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  // Track: h-5 w-9 rounded-full, off = bg-surface-highest, on = bg-primary
  const switchClasses = [
    'relative w-9 h-5 rounded-full',
    checked ? 'bg-primary' : 'bg-surface-highest',
    'cursor-pointer flex-shrink-0',
    'interactive transition-colors',
  ]
    .filter(Boolean)
    .join(' ')

  // Thumb: h-4 w-4 rounded-full, off = bg-on-surface-variant, on = bg-on-primary, translates on toggle.
  // The slide is a transform, which logical properties don't cover, so RTL gets
  // an explicit mirrored translate rather than a start/end position.
  const thumbClasses = [
    'absolute top-0.5 start-0.5 w-4 h-4 rounded-full',
    checked ? 'bg-on-primary translate-x-4 rtl:-translate-x-4' : 'bg-on-surface-variant',
    'transition-transform duration-short',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <label className={containerClasses}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        role="switch"
        aria-checked={checked}
        className="sr-only"
      />
      <div className={switchClasses}>
        <div className={thumbClasses} />
      </div>
      {label && <span className="text-body-md text-on-surface">{label}</span>}
    </label>
  )
}
